import { render, staticRenderFns } from "./article.block.pug?vue&type=template&id=2a6f62a2&scoped=true&lang=pug&external"
import script from "./article.block.ts?vue&type=script&lang=ts&external"
export * from "./article.block.ts?vue&type=script&lang=ts&external"
import style0 from "./article.block.sass?vue&type=style&index=0&id=2a6f62a2&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f62a2",
  null
  
)

export default component.exports